import React, { useState } from "react";

import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import AdminOrganizationsStatisticsActions from "../../../components/Admin/AdminOrganizationsStatisticsComponents/AdminOrganizationsStatisticsActions";
import AdminOrganizationsStatistics from "../../../components/Admin/AdminOrganizationsStatisticsComponents/AdminOrganizationsStatisticsTable";
import "../../../components/Admin/AdminOrganizationsStatisticsComponents/index.css";

const OrganizationsStatistics = () => {
  const [statisticsTypeValue, setStatisticsTypeValue] = useState("visits");
  const [statisticsArray, setStatisticsArray] = useState([]);

  return (
    <>
      <PageHeader text="Статистика" />
      <AdminOrganizationsStatisticsActions
        setStatisticsArray={setStatisticsArray}
        setStatisticsTypeValue={setStatisticsTypeValue}
      />
      <AdminOrganizationsStatistics
        statisticsArray={statisticsArray}
        setStatisticsArray={setStatisticsArray}
        statisticsTypeValue={statisticsTypeValue}
      />
    </>
  );
};
export default OrganizationsStatistics;
